// src/ProtectedRoute.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

export default function ProtectedRoute({ children, requireSubscription = false }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        console.log("🚫 No user logged in. Redirecting...");
        navigate("/login", { replace: true });
        return;
      }

      const userEmail = firebaseUser.email;
      const isModerator = userEmail === "realsautomated@gmail.com";

      if (!requireSubscription) {
        // No subscription required, any login is fine
        setUser(firebaseUser);
        setLoading(false);
        return;
      }

      // Check subscription from Firestore
      try {
        const subRef = doc(db, "subscribers", userEmail);
        const subSnap = await getDoc(subRef);

        if (subSnap.exists() || isModerator) {
          console.log("✅ Access granted to premium dashboard");
          setUser(firebaseUser);
        } else {
          console.log("🚫 No subscription found. Redirecting to offer page...");
          navigate("/offer", { replace: true });
        }
      } catch (err) {
        console.error("❌ Firestore error:", err.message);
        navigate("/offer", { replace: true });
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate, requireSubscription]);

  if (loading) return <p className="text-center p-6">Loading...</p>;

  return children;
}
